import { useCallback, useState } from 'react';

import type {
  FWeeklyScheduleDeleteHandler,
  FWeeklyScheduleItem,
} from '../../../../../../components/baseV2';
import type { UseScheduleDeleteDialogParams } from './types';

export default function useScheduleDeleteDialog({ onDelete }: UseScheduleDeleteDialogParams) {
  const [pendingDeleteId, setPendingDeleteId] = useState<FWeeklyScheduleItem['id'] | null>(null);

  const requestDeleteSchedule = useCallback<FWeeklyScheduleDeleteHandler>((scheduleId) => {
    setPendingDeleteId(scheduleId);
  }, []);

  const cancelDeleteSchedule = useCallback(() => {
    setPendingDeleteId(null);
  }, []);

  // Redux Toolkit dispatch resolves with a rejected action instead of throwing, so the hook
  // reports success as a boolean — keep the dialog open on failure so it can be retried.
  const confirmDeleteSchedule = useCallback(async () => {
    if (pendingDeleteId === null) return;
    const deleted = await onDelete(pendingDeleteId);
    if (deleted) {
      setPendingDeleteId(null);
    }
  }, [onDelete, pendingDeleteId]);

  return {
    isDeleteDialogOpen: pendingDeleteId !== null,
    requestDeleteSchedule,
    confirmDeleteSchedule,
    cancelDeleteSchedule,
  };
}
